import { render } from "./ctrl-btn-click-dbclick.vue?vue&type=template&id=4da5ba29&scoped=true&ts=true"
import script from "./ctrl-btn-click-dbclick.vue?vue&type=script&lang=ts"
export * from "./ctrl-btn-click-dbclick.vue?vue&type=script&lang=ts"

import "./ctrl-btn-click-dbclick.vue?vue&type=style&index=0&id=4da5ba29&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da5ba29"]])

export default __exports__